// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"40":"add","177":"home","497":"single"}[chunkId] || chunkId) + "-legacy." + {"40":"c92c22c5","177":"49e9e720","497":"4786a6c5","574":"5462e01e"}[chunkId] + ".js";
};